/**
 * Denormalized employee fields persisted on clocking at create time.
 * Keep in sync with hr-app/libs/clocking-employee-snapshot.js
 */
export const CLOCKING_EMPLOYEE_SNAPSHOT_KEYS = [
  "employeeFirstName",
  "employeeLastName",
  "employeeFullName",
  "employeeRoleId",
  "employeeRoleName",
  "employeeDepartmentId",
  "employeeDepartmentName",
  "employeeTeam",
  "breakTime",
  "isBreakTimePaid",
  "employeePayrollType",
  "employeeTypeOfEmployment",
];

export function buildEmployeeFullName(firstName, lastName) {
  const full = [firstName, lastName]
    .filter((part) => typeof part === "string" && part.trim() !== "")
    .join(" ")
    .trim();
  return full || null;
}

export function buildClockingEmployeeSnapshot(employee) {
  if (!employee || typeof employee !== "object") {
    return CLOCKING_EMPLOYEE_SNAPSHOT_KEYS.reduce((acc, key) => {
      acc[key] = null;
      return acc;
    }, {});
  }

  const first = employee.employeeFirstName ?? null;
  const last = employee.employeeLastName ?? null;

  return {
    employeeFirstName: first,
    employeeLastName: last,
    employeeFullName:
      employee.employeeFullName || buildEmployeeFullName(first, last),
    employeeRoleId: employee.employeeRoleId ?? null,
    employeeRoleName: employee.employeeRoleName ?? null,
    employeeDepartmentId: employee.employeeDepartmentId ?? null,
    employeeDepartmentName: employee.employeeDepartmentName ?? null,
    employeeTeam: employee.employeeTeam ?? null,
    breakTime: Array.isArray(employee.breakTime) ? employee.breakTime : null,
    isBreakTimePaid:
      typeof employee.isBreakTimePaid === "boolean"
        ? employee.isBreakTimePaid
        : null,
    employeePayrollType: employee.employeePayrollType ?? null,
    employeeTypeOfEmployment: employee.employeeTypeOfEmployment ?? null,
  };
}

/** Resolve employee object from a single record or list by employeeId. */
export function resolveEmployeeForSnapshot(employeeOrEmployees, employeeId) {
  if (!employeeOrEmployees) return null;
  if (Array.isArray(employeeOrEmployees)) {
    return (
      employeeOrEmployees.find((e) => e?.employeeId === employeeId) || null
    );
  }
  if (
    typeof employeeOrEmployees === "object" &&
    employeeOrEmployees.employeeId
  ) {
    return employeeOrEmployees;
  }
  return null;
}
